import type { TenantConfig } from '@/types/TenantConfig'

export const theworkshops: TenantConfig = {
  logo: 'assets/theworkshops/static/logo-white.png',
  themeOptions: {
    dialog: {
      headerBackground: '#EBEBEB',
    },
    mobileFooter: {
      textColor: '#333333',
      priceTextColor: '#333333',
    },
  },
  teaserImageSize: {
    width: 350,
    height: 350,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/theworkshops/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-100px',
      },
    },
  },
}
